export const LanguageConst = {
    English: {
        name: 'English'
    },
    Chinese: {
        name: 'Chinese'
    },
    Tamil: {
        name: 'Tamil'
    },
    Malay: {
        name: 'Malay'
    }
}
